import {
	DELETE_MODULE,
	DELETE_MODULE_SUCCESS,
	DELETE_MODULE_FAIL,
	DELETE_MODULE_RESET,
} from '../actions/deleteModuleAction';

const initialState = {
	apiState: '',
	message: '',
	data: null,
	error: '',
};

const deleteModuleReducer = (state = initialState, action) => {
	switch (action.type) {
		case DELETE_MODULE:
			return {
				...state,
				apiState: 'loading',
			};
		case DELETE_MODULE_SUCCESS:
			return {
				...state,
				apiState: 'success',
				data: action.response.data,
				message: action.response.message
					? action.response.message
					: 'success',
			};
		case DELETE_MODULE_FAIL:
			return {
				...state,
				apiState: 'error',
				error: action.response.errors,
				message: action.response.message
					? action.response.message
					: 'error',
			};
		case DELETE_MODULE_RESET:
			return initialState;
		default:
			return state;
	}
};

export default deleteModuleReducer;
